module.exports = __webpack_public_path__ + "567d413b9d36230b252c53b174ad3502.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/es.json
// module id = 1118
// module chunks = 0